module.exports = __webpack_public_path__ + "static/scale-model-of-visit-jacksonville-in-jacksonville-florida-76661873d62df0d56cd887a3ef70d1d6.png";